import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { EntityMediaFragmentDoc } from '../../../../../../../../../features/messages/graphql/fragments/generated/MediaType';
export type QuestionEditorParentContents_ArticleContentType_Fragment = {};

export type QuestionEditorParentContents_BaseResourceSchema_Fragment = {};

export type QuestionEditorParentContents_CheckinType_Fragment = {};

export type QuestionEditorParentContents_CourseContentType_Fragment = { id: string, name: string, type: Types.ResourceTypeEnum, cover?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null };

export type QuestionEditorParentContents_ExerciseType_Fragment = {};

export type QuestionEditorParentContents_ExternalContentType_Fragment = {};

export type QuestionEditorParentContents_ExternalEventContentType_Fragment = { id: string, name: string, type: Types.ResourceTypeEnum, cover?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null };

export type QuestionEditorParentContents_HomeworkType_Fragment = {};

export type QuestionEditorParentContents_KnowledgeAssetContentType_Fragment = {};

export type QuestionEditorParentContents_LiveEventContentType_Fragment = {};

export type QuestionEditorParentContents_MicroLearningContentType_Fragment = {};

export type QuestionEditorParentContents_OfflineEventContentType_Fragment = { id: string, name: string, type: Types.ResourceTypeEnum, cover?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null };

export type QuestionEditorParentContents_PathContentType_Fragment = { id: string, name: string, type: Types.ResourceTypeEnum, cover?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null };

export type QuestionEditorParentContents_QuizContentType_Fragment = { id: string, name: string, type: Types.ResourceTypeEnum, cover?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null };

export type QuestionEditorParentContents_RecurringExternalEventContentType_Fragment = {};

export type QuestionEditorParentContents_RecurringLiveEventContentType_Fragment = {};

export type QuestionEditorParentContents_RecurringOfflineEventContentType_Fragment = {};

export type QuestionEditorParentContents_RoleplayContentType_Fragment = { id: string, name: string, type: Types.ResourceTypeEnum, cover?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null };

export type QuestionEditorParentContents_ScormContentType_Fragment = {};

export type QuestionEditorParentContents_SurveyContentType_Fragment = {};

export type QuestionEditorParentContents_TaskContentType_Fragment = {};

export type QuestionEditorParentContentsFragment = QuestionEditorParentContents_ArticleContentType_Fragment | QuestionEditorParentContents_BaseResourceSchema_Fragment | QuestionEditorParentContents_CheckinType_Fragment | QuestionEditorParentContents_CourseContentType_Fragment | QuestionEditorParentContents_ExerciseType_Fragment | QuestionEditorParentContents_ExternalContentType_Fragment | QuestionEditorParentContents_ExternalEventContentType_Fragment | QuestionEditorParentContents_HomeworkType_Fragment | QuestionEditorParentContents_KnowledgeAssetContentType_Fragment | QuestionEditorParentContents_LiveEventContentType_Fragment | QuestionEditorParentContents_MicroLearningContentType_Fragment | QuestionEditorParentContents_OfflineEventContentType_Fragment | QuestionEditorParentContents_PathContentType_Fragment | QuestionEditorParentContents_QuizContentType_Fragment | QuestionEditorParentContents_RecurringExternalEventContentType_Fragment | QuestionEditorParentContents_RecurringLiveEventContentType_Fragment | QuestionEditorParentContents_RecurringOfflineEventContentType_Fragment | QuestionEditorParentContents_RoleplayContentType_Fragment | QuestionEditorParentContents_ScormContentType_Fragment | QuestionEditorParentContents_SurveyContentType_Fragment | QuestionEditorParentContents_TaskContentType_Fragment;


export type QuestionEditorParentContentsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const QuestionEditorParentContentsFragmentDoc = /*#__PURE__*/ gql`
    fragment QuestionEditorParentContents on ContentEntity {
  ... on QuizContentType {
    id
    name
    type
    cover {
      ...EntityMedia
    }
  }
  ... on CourseContentType {
    id
    name
    type
    cover {
      ...EntityMedia
    }
  }
  ... on PathContentType {
    id
    name
    type
    cover {
      ...EntityMedia
    }
  }
  ... on OfflineEventContentType {
    id
    name
    type
    cover {
      ...EntityMedia
    }
  }
  ... on ExternalEventContentType {
    id
    name
    type
    cover {
      ...EntityMedia
    }
  }
  ... on RoleplayContentType {
    id
    name
    type
    cover {
      ...EntityMedia
    }
  }
}
    `;